<template>
  <div id="payment-methods-container">
    <!-- Seccion de entrega  -->
    <b-card title="Datos de Entrega" class="mt-5">
      <p>Ingresa el nombre completo de la persona que firmar� de recibido.</p>
      <div class="row">
        <div class="col-12">
          <b-input
            v-model="receiver.name"
            placeholder="Nombre de la persona que recibe"
          ></b-input>
          <br />
          <small class="ml-0 pl-0 mt-2"
            >En caso de dejar en blanco se pondr� a nombre del titular de la
            cuenta</small
          >
        </div>
      </div>
    </b-card>
    <b-card title="Metodos de Pago" class="my-3">
      <!-- metodos de pago tabs -->
      <div class="mt-5 border p-3 mb-5">
        <h2 class="h3 mb-3 mt-3 text-black">Selecciona el m&eacute;todo de pago</h2>
        <nav class="nav nav-pills nav-justified align-items-center">
          <!-- Stripe -->
          <a
            type="button"
            id="btnStripe"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
            @click="paymentType(6)"
            ><img
              src="images/img_estilos/stripe.png"
              alt="Stripe"
              loading="lazy"
              style="width: 85px; height: 40px; object-fit: contain"
          /></a>
          <!-- OpenPay -->
          <!-- <a
            type="button"
            id="btnOpenPay"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5 activeTab"
            @click="paymentType(5)"
          >
            <img
              src="images/img_estilos/btnOpenPay.png"
              alt="Openpay"
              loading="lazy"
              style="width: 85px; height: 40px; object-fit: contain"
            />
          </a> -->
          <!-- Conekta -->
          <!--<a
            type="button"
            id="btnCards"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
            @click="paymentType(1)"
            ><img
              src="images/img_estilos/btnCards.png"
              alt="Cards"
              loading="lazy"
              style="width: 85px; height: 40px; object-fit: contain"
          /></a> -->
          <!-- Paypal -->
          <!-- <a
            type="button"
            id="btnPaypal"
            class="nav-item mx-2 nav-link btn btn-default px-2 px-md-3 px-lg-5"
            @click="paymentType(4)"
            ><img
              src="images/img_estilos/btnPaypal.png"
              alt="Paypal"
              loading="lazy"
              style="width: 85px; height: 40px; object-fit: contain"
          /></a> -->
        </nav>
      </div>
      <!-- Conekta -->
      <Conekta
        :is_card="is_card"
        :card_months="card_months"
        :card_years="card_years"
        :total="total"
        :receiver="receiver"
        :userData="userData" 
        :products="products" 
        :address="address"
      >
      </Conekta>
      <!-- Paypal -->
      <!-- <Paypal v-show="is_paypal" :is_paypal="is_paypal" :receiver="receiver" :userData="userData" :products="products" :address="address"></Paypal> -->
      <div v-show="is_paypal">
        <Paypal 
        :tempTokenPaypal=this.tempTokenPaypal
        :addressData=this.address
        :products=this.products
        :codeCoupon=null
        @statusLoading="changeStatusLoading($event)"
      ></Paypal>
      </div>
      <!-- OpenPay -->
      <open-pay
        :is_openpay="is_openpay"
        :card_months="card_months"
        :card_years="card_years"
        :total="total"
        :address="address"
        :receiver="receiver"
        :userData="userData" 
        :products="products" 
      >
      </open-pay>

      <div v-show="is_stripe">      
        <Stripe 
          :showForm="is_stripe"
          :addressData="address"
          :products="products"
          :codeCoupon=null
          @statusLoading="changeStatusLoading($event)"
        ></Stripe>
      </div>
      
    </b-card>
  </div>
</template>

<script>
import Conekta from "@/components/Payment/GuestPayments/Conekta.vue";
import OpenPay from "@/components/Payment/GuestPayments/OpenPay.vue";
import Stripe from "@/components/Stripe/Stripe.vue";
import Paypal from "@/components/Paypal/Paypal.vue";

export default {
  name: "PaymentMethods",
  props: ["products", "address", "userData"],
  components: {
    Conekta,
    Paypal,
    OpenPay,
    Stripe,
  },
  data() {
    return {
      total: 0,
      is_card: false,
      is_paypal: false,
      is_openpay: false,
      is_stripe: false,
      card_months: [],
      card_years: [],
      receiver: {
        name: "",
      },
      tempTokenPaypal: "",
    };
  },
  mounted(){
    console.log("datos por props productos ", this.products);
    console.log("datos por props direccion", this.address);
    console.log("datos por props datos del usuario", this.userData);
  },
  created() {
    this.card_months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    this.card_years.push(2022);
    this.card_years.push(2023);
    this.card_years.push(2024);
    this.card_years.push(2025);
    this.card_years.push(2026);
    this.card_years.push(2027);
    this.card_years.push(2028);
    this.card_years.push(2029);
    this.card_years.push(2030);
    this.card_years.push(2031);
    this.card_years.push(2032);
    this.card_years.push(2033);


    // Verificacion de token de paypal
    const queryString = window.location.href;
    console.log("url: ",  queryString);
    const myArray = queryString.split("session_id=");
    this.tempTokenPaypal = myArray[1];

    if(this.tempTokenPaypal !== undefined){
      console.info("token paypal: ", this.tempTokenPaypal);
      this.products = JSON.parse(localStorage.getItem('temporalProductsPaypal'));
      this.addressData = JSON.parse(localStorage.getItem('temporalAddressPaypal'));
      this.codeCoupon = JSON.parse(localStorage.getItem('temporalCodeCouponPaypal'));
      this.showTotal = true;
      this.is_paypal = true;
    }


  },
  methods: {
    changeStatusLoading(boolean){
      console.log("recibiendo: ", boolean);
      this.$emit("statusLoader", boolean);
    },
    paymentType: function (type) {
      switch (type) {
        case 4:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = true;
          this.is_openpay = false;
          this.is_stripe = false;
          this.$emit("statusLoader", false);
          break;

        case 5:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = true;
          this.is_stripe = false;
          this.$emit("statusLoader", false);
          break;

        case 6:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = true;
          this.$emit("statusLoader", true);
          break;

        case 1:
          this.is_card = true;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = false;
          this.$emit("statusLoader", false);
          break;


          default:
          this.is_card = false;
          this.is_transfer = false;
          this.is_oxxo = false;
          this.is_paypal = false;
          this.is_openpay = false;
          this.is_stripe = false;
          break;
      }
    },
  },
};
</script>

<style scoped>
</style>